import { useMachine } from '@xstate/react';
import { useCallback } from 'react';

import {
  createGoogleSignInMachine,
  GoogleSignInState,
} from './google-signin-machine';
import { logInWithGoogle } from './sso';

export function useGoogleSignIn({
  baseUrl,
  product,
  useCustomRlifeSocialAuth,
  on,
}: {
  baseUrl: string;
  product: string;
  useCustomRlifeSocialAuth: boolean;
  on: Parameters<typeof createGoogleSignInMachine>[0]['on'];
}) {
  const [state, send] = useMachine(() =>
    createGoogleSignInMachine({
      logInWithGoogle: ({ accessToken }) =>
        logInWithGoogle({
          baseUrl,
          product,
          useCustomRlifeSocialAuth,
          accessToken,
        }),
      on,
    }),
  );

  const googleSignInState: GoogleSignInState | null = state.matches('idle')
    ? { value: 'idle', context: state.context }
    : state.matches('logging in with google')
    ? { value: 'logging in with google', context: state.context }
    : state.matches('google log in succeeded')
    ? { value: 'google log in succeeded', context: state.context }
    : state.matches('google log in failed')
    ? { value: 'google log in failed', context: state.context }
    : null;

  if (!googleSignInState) {
    throw new Error('Unable to derive google signin state');
  }

  const googleLogIn = useCallback(
    ({ gAccessToken }: { gAccessToken: string }) => {
      send({ type: 'log in with google', gAccessToken });
    },
    [send],
  );

  return {
    googleSignInState,
    googleLogIn,
  };
}
